import { isWorkflowRunActive } from '@/lib/workflows/workflowRunStatus.js';

/*
 * The step the newest in-flight run is currently executing, or null when nothing is running.
 *
 * Scoped to ACTIVE runs on purpose: once a run is terminal the canvas goes back to showing structure
 * only. A finished run's step status is the run-logs modal's job, and it does it properly — with the
 * scrubber and per-iteration detail a single highlight cannot express. Keeping the highlight after a
 * run ends would also go stale the moment the draft is edited, pointing at a step id that has since
 * been moved or deleted.
 *
 * `runs` arrives newest-first from activeThreadWorkflowRunsList.
 */
const resolveActiveWorkflowRunStepId = (runs) => {
  const activeRun = runs.find(isWorkflowRunActive);

  return String(activeRun?.activeStepId || '').trim() || null;
};

export default resolveActiveWorkflowRunStepId;
